// extracted by mini-css-extract-plugin
export default {"container":"SuperBatchSelect_container__kEMcI"};